import { useEffect, useRef } from 'react';

/**
 * Traps hardware / browser Back gesture while a modal sheet or dialog is open,
 * closing the sheet on Back instead of navigating away from the current page.
 */
export function useHistoryDismiss(open: boolean, onClose: () => void): void {
  const isPushedRef = useRef(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (open) {
      if (!isPushedRef.current) {
        const currentState = window.history.state || {};
        window.history.pushState(
          { ...currentState, __sheetDismiss: true, idx: (currentState.idx ?? 0) + 1 },
          ''
        );
        isPushedRef.current = true;
      }

      const handlePopState = () => {
        if (isPushedRef.current) {
          isPushedRef.current = false;
          onClose();
        }
      };

      window.addEventListener('popstate', handlePopState);

      return () => {
        window.removeEventListener('popstate', handlePopState);
        if (isPushedRef.current) {
          isPushedRef.current = false;
          if (window.history.state?.__sheetDismiss) {
            window.history.back();
          }
        }
      };
    } else {
      if (isPushedRef.current) {
        isPushedRef.current = false;
        if (window.history.state?.__sheetDismiss) {
          window.history.back();
        }
      }
    }
  }, [open, onClose]);
}
